import React, { useState, useEffect } from 'react';
import { Provider, useSelector } from 'react-redux';
import { compose } from 'redux';

import store from '../../store';
import { FIRST_PAGE } from '../../constants/pagination';
import { useFetchStatus } from '../../utils/fetchStatusUtils';
import {
  cashbacksRestHooks,
  selectEndate,
  selectStartdate,
} from '../../store/Cashbacks/CashbacksSlice';
import { storesRestHooks } from '../../store/Stores/StoresSlice';
import useCashbacksData from '../../hooks/Reports/useCashbacksData';
import { STATES } from '../../presenters/CashbackPresenter';

import CashbacksData from './components/CashbacksData';
import CashbacksFilters from './components/CashbacksFilters';
import Cashbacks from './components/Cashbacks';

const CashbacksDashboardContainer = () => {
  const endDate = useSelector(selectEndate);
  const startDate = useSelector(selectStartdate);

  const initialParams = {
    afterDate: startDate,
    beforeDate: endDate,
    storeIdEq: '',
    byUser: '',
    quarantinedReasonIn: [],
    stateIn: [STATES.pending, STATES.available],
  };
  const [searchParams, setSearchParams] = useState({
    q: initialParams,
    page: FIRST_PAGE,
  });

  const handlePageChange = ({ selected }) => {
    const newParams = { ...searchParams, page: selected + 1 };
    setSearchParams(newParams);

    loadCashbacks(newParams);
  };

  const {
    loadCashbacks,
    cashbacks: { loadingStatus, items, meta },
  } = cashbacksRestHooks.use();

  const { cashbacksData, loadCashbacksData, cashbacksDataLoadingState } =
    useCashbacksData();

  const { isIdleCashbacksData } = useFetchStatus(cashbacksDataLoadingState);
  const { isIdleCashbacks } = useFetchStatus(loadingStatus);

  const {
    loadStores,
    stores: { loadingStatus: storesLoadingState, items: stores },
  } = storesRestHooks.use();

  const loadData = (newParams) => {
    loadCashbacks(newParams);
    loadCashbacksData(newParams);
  };

  useEffect(() => {
    loadStores();
  }, []);

  return (
    <div className="cashbacks">
      <h2>Cashbacks Dashboard</h2>
      <CashbacksFilters
        searchParams={searchParams}
        onSearchParamsChange={setSearchParams}
        stores={stores}
        storesLoadingState={storesLoadingState}
        onLoadData={loadData}
      />
      {!isIdleCashbacksData && (
        <CashbacksData
          cashbacksData={cashbacksData}
          loadingState={cashbacksDataLoadingState}
        />
      )}
      {!isIdleCashbacks && (
        <Cashbacks
          cashbacks={items}
          meta={meta}
          onPageChange={handlePageChange}
          loadingState={loadingStatus}
        />
      )}
    </div>
  );
};

const addStore = (ProxyComponent) => (props) =>
  (
    <Provider store={store}>
      <ProxyComponent {...props} />
    </Provider>
  );

export default compose(addStore)(CashbacksDashboardContainer);
